import { FDealType, FOfferType, isAvailable } from 'shared/common/packages/JsonQuery';

import { MortgagePromoSearchTypeContainer } from '../../containers/advancedFilters/MortgagePromoSearchTypeContainer';
import { IFilter } from '../../types/advancedFilters';

export const mortgagePromoSearchType: IFilter = {
  component: MortgagePromoSearchTypeContainer,
  availability: jsonQuery => isAvailable(FDealType.Sale, FOfferType.FlatNew)(jsonQuery),
};
